export class Ledger {
    Id:Number ;
    LedgerName :String ;
    IsSubLedger :boolean ;
    SubLedgerId : Number;
    SubLedgerName :String ;
    AccountId :Number ;
    IsAllCompany:boolean;
    EmployeeId :Number ;
    EmployeeBranchId :Number ;
    CompanyId :Number ;
    SaasId :Number ;
    IsActive  :Number;
    Flag : Number;

    BranchId : number;
    CreatedDate:Date;
    IsBranchWise:boolean;
}